/**
 * Auto-generated by: https://github.com/pmndrs/gltfjsx
 * Command: npx gltfjsx@6.5.0 orion_9slotrack.glb -T 
 * Files: orion_9slotrack.glb [64.62MB] > C:\Users\eduardo.vieira\frontendOrion\public\models\orion_9slotrack-transformed.glb [3.11MB] (95%)
 */


import React from 'react'
import { useGLTF } from '@react-three/drei'

export function Rack9slotModel(pos) {
  const { nodes, materials } = useGLTF('/models/rack9slot2-transformed.glb')
  return (
    <group position={[122,-8.5,1.8]} dispose={null} rotation={[Math.PI/2,0,0]} >
      <mesh geometry={nodes['7362298480044'].geometry} material={materials.PaletteMaterial002} />
      <mesh geometry={nodes['7362298480044_1'].geometry} material={materials.PaletteMaterial001} />
    </group>
  )
}

useGLTF.preload('/models/rack9slot2-transformed.glb')